import * as ActionTypes from './types';
import { actionCreator } from '../helpers/actionCreator';

export const setTabVisibility = actionCreator(ActionTypes.SET_TAB_VISIBILITY);
export const setUserAgentInfo = actionCreator(ActionTypes.SET_USER_AGENT_INFO);
export const nullAction = actionCreator(ActionTypes.NULL_ACTION);
